import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { CUSTOMER_DETAILS } from '../../steps';
import Button from '../button';

export default function({ onConfirm = () => {} }) {
  const {
    continueButton,
    customerDetails: { component },
  } = useSelector(state => state.pageText);

  return (
    <Wrapper>
      <p>
        <b>&#10148; </b>
        {component.unableToVerify1}
      </p>

      <p>
        <b>&#10148; </b>
        {component.unableToVerify2}
      </p>

      <Button
        className="confirm"
        disabled={false}
        name="Continue (unable to verify)"
        onClick={onConfirm}
        step={CUSTOMER_DETAILS}
      >
        {continueButton}
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  p {
    display: flex;
    text-align: left;
  }
  b {
    color: #3db0fb;
    padding-right: 10px;
  }
`;
